const daysUntil = (iso) => {
  const today = new Date(); today.setHours(0, 0, 0, 0);
  return Math.round((new Date(`${iso}T00:00:00`) - today) / 86400000);
};

export const DueBadge = ({ date, id }) => {
  const d = daysUntil(date);
  const label = d < 0 ? `Overdue by ${-d} day${d === -1 ? "" : "s"}` : d === 0 ? "Due today" : `Due in ${d} day${d === 1 ? "" : "s"}`;
  const tone = d <= 0 ? "bg-red-500/15 text-red-600 dark:text-red-400 border-red-500/30"
    : d <= 3 ? "bg-amber-500/15 text-amber-700 dark:text-amber-400 border-amber-500/30"
      : "bg-secondary text-muted-foreground border-border";
  return (
    <span data-testid={`due-badge-${id}`} className={`inline-flex items-center rounded-full border px-2 py-0.5 text-[0.7rem] font-semibold whitespace-nowrap ${tone}`}>
      {label}
    </span>
  );
};
